import * as React from 'react';
import Icon from 'antd/lib/icon';
import Select from 'antd/lib/select';
import { KeyLabel } from 'src/Library/Types';
import { CommonProps } from './common.intefaces';
import { isValidArray } from 'src/Library/Helper';
import { fetchAllTeams } from 'src/api/teams';
import { accessOptions } from 'src/Library/Constants';
import {
  defaultAccessKeys,
  visibleAccessTypeLabel,
} from 'src/components/pages/Enquiry/InquiryUtils';

interface IProps extends CommonProps {
  visibleAccessTypes?: string[];
  organisationId?: string;
}

const SelectAccess = (props: IProps) => {
  const {
    mode,
    style,
    value,
    onChange,
    disabled,
    className,
    placeholder,
    visibleAccessTypes,
    organisationId
  } = props;

  const [teamOptions, setTeamOptions] = React.useState<KeyLabel[]>([]);

  React.useEffect(() => {
    searchTeams();
  }, []);

  async function searchTeams() {
    const response = await fetchAllTeams({ adminTeamRestriction: true });
    const data = response.data || [];
    const filteredTeams = organisationId ? data.filter(team => team.organisation_id === organisationId) : data;
    setTeamOptions(getKeyLabelFromArray(filteredTeams));
  }

  function getKeyLabelFromArray(inputArray): KeyLabel[] {
    if (!isValidArray(inputArray)) return [];
    return inputArray.map((item) => ({
      key: item.id,
      label: item.name,
    }));
  }

  const accessIcons = {
    TEAM: <Icon type="team" />,
    PUBLIC: <Icon type="global" />,
    PRIVATE: <Icon type="user" />,
  };

  const renderAccessOptions = () => {
    const sortedAccessKeys = [...defaultAccessKeys].sort((a, b) => {
      if (!visibleAccessTypes?.length) return 0;
      return Number(visibleAccessTypes.includes(b)) - Number(visibleAccessTypes.includes(a));
    });

    return sortedAccessKeys.map((key) => (
      <Select.Option
        disabled={!!visibleAccessTypes?.length && !visibleAccessTypes.includes(key)}
        key={key}
      >
        {accessIcons[key]} &nbsp;
        {visibleAccessTypeLabel[key]}
      </Select.Option>
    ));
  };

  return (
    <Select
      style={{
        ...(style || {}),
      }}
      allowClear
      showSearch
      labelInValue
      value={value}
      disabled={disabled}
      onChange={onChange}
      className={className}
      mode={mode || 'default'}
      placeholder={placeholder || 'Select Access'}
      getPopupContainer={(trigger: any) => trigger.parentNode}
    >
      {renderAccessOptions()}
    </Select>
  );
};

export default React.memo(SelectAccess);
